import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["file-input"];
  static targets = ["urlInput", "uploadFileTab", "googleDriveTab", "attachLinkTab"];

  uploadFileTabTargetConnected(element) {
    element.addEventListener("shown.bs.tab", this.openFileSelector.bind(this));
  }

  googleDriveTabTargetConnected(element) {
    element.addEventListener("shown.bs.tab", this.openGoogleDrivePicker.bind(this));
  }

  attachLinkTabTargetConnected(element) {
    element.addEventListener("shown.bs.tab", this.focusUrlInput.bind(this));
  }

  openFileSelector() {
    this.clearUrlInput();
    if (this.hasFileInputOutlet) {
      this.fileInputOutlet.inputTarget.click();
    }
  }

  openGoogleDrivePicker() {
    const googleDrivePane = document.querySelector("#google_drive_pane");
    if (googleDrivePane) {
      const inputGroup = googleDrivePane.querySelector("[data-action*='google-drive#initPicker']");
      if (inputGroup) {
        inputGroup.click();
      }
    }
  }

  clearUrlInput() {
    if (this.hasUrlInputTarget) {
      this.urlInputTarget.value = "";
    }
  }

  focusUrlInput() {
    if (this.hasUrlInputTarget) {
      this.urlInputTarget.focus();
    }
  }

  clearFileSelection() {
    if (this.hasFileInputOutlet) {
      // uses `new DataTransfer().files` because empty FileLists cannot be constructed directly
      this.fileInputOutlet.setFiles(new DataTransfer().files);
    }
  }
}
